import { SWAN_STYLE_KEY_MAP } from '@vp/swan'
import { IdentityProvider, useSwanStyleKeys, useUserContext } from '@vp/ubik-context'
import { App } from './App'
import { Article } from './types/article.type'
import LocalizationProvider from './components/providers/LocalizationProvider'
import { useEffect } from 'react'
import { initCA } from '@vp/chat-anywhere'
import { isChatEnabled } from './utils/chat.utils'
import { HelpCenterUrls } from './types/helpCenterUrls.type'

export interface Props {
  article: Article | null
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  localisation: Record<string, any>
  config?: {
    hcServiceUrl: string
    useStaging?: boolean
  }
  helpCenterUrls: HelpCenterUrls | null
}

const styleSheetKeys = [
  SWAN_STYLE_KEY_MAP.button,
  SWAN_STYLE_KEY_MAP.accordion,
  SWAN_STYLE_KEY_MAP.grid,
  SWAN_STYLE_KEY_MAP.modalDialog,
  SWAN_STYLE_KEY_MAP.hidden,
  SWAN_STYLE_KEY_MAP.icon,
  SWAN_STYLE_KEY_MAP.toggleSwitch,
  SWAN_STYLE_KEY_MAP.core,
  SWAN_STYLE_KEY_MAP.visible,
  SWAN_STYLE_KEY_MAP.standardTile,
  SWAN_STYLE_KEY_MAP.progressiveImage,
  SWAN_STYLE_KEY_MAP.utility,
  SWAN_STYLE_KEY_MAP.popover,
  SWAN_STYLE_KEY_MAP.alertBox,
  SWAN_STYLE_KEY_MAP.carousel,
  SWAN_STYLE_KEY_MAP.spinner,
  SWAN_STYLE_KEY_MAP.stepIndicator,
  SWAN_STYLE_KEY_MAP.selectionSet,
  SWAN_STYLE_KEY_MAP.banner,
  SWAN_STYLE_KEY_MAP.listbox,
]

export const createAuthConfig = (culture: string, isDevelopment = false) => ({
  culture,
  developmentMode: isDevelopment,
  options: {
    requireSession: true,
    customText: 'Sign in to see your account',
  },
})
export const Fragment = (props: Props) => {
  const { locale, tenant } = useUserContext()

  useSwanStyleKeys(styleSheetKeys)

  if (!props.article) return null

  useEffect(() => {
    if (isChatEnabled(locale)) initCA()
  }, [locale])

  return (
    <LocalizationProvider locale={locale} localizationData={props.localisation}>
      <IdentityProvider auth={createAuthConfig(locale)}>
        <App locale={locale} tenant={tenant || 'vistaprint'} article={props.article} config={props.config} helpCenterUrls={props.helpCenterUrls} />
      </IdentityProvider>
    </LocalizationProvider>
  )
}
